export const SALESFORCE_ROOT_PATH =
  'lcc/:id/hubtype_apps__hubtypechat/index.html'
